module.exports = __webpack_public_path__ + "static/media/chevron-up.5a1b1594.svg";